import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "",
    name: "home",
    meta: { layout: "LayoutsDefault", guest: true },
    component: () => import("../views/PortalView.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { layout: "LayoutsAuthen", requiresNotAuth: true },
    component: () => import("../views/SignInView.vue"),
  },
  {
    path: "/forgetpassword",
    name: "forgetpassword",
    meta: { layout: "LayoutsAuthen", requiresNotAuth: true },
    component: () => import("../views/ForgetPasswordView.vue"),
  },
  {
    path: "/register",
    name: "register",
    meta: { layout: "LayoutsAuthen", requiresNotAuth: true },
    component: () => import("../views/signUp/SignUpView.vue"),
  },
  {
    path: "/register/otp-confirm/:user_id",
    name: "register-confirm",
    meta: { layout: "LayoutsDefault", requiresNotAuth: true },
    component: () => import("../views/signUp/SignUpOTPConfirm.vue"),
  },
  {
    path: "/about",
    name: "about",
    meta: { layout: "LayoutsDefault", guest: true },
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/legislation",
    name: "legislation",
    meta: { layout: "LayoutsDefault", guest: true },
    component: () => import("../views/LegislationView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    meta: { layout: "LayoutsDefault", guest: true },
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/attachments",
    name: "document-attachments",
    meta: { layout: "LayoutsDefault", guest: true },
    component: () => import("../views/documentView/EntreatyAttac.vue"),
  },
  {
    path: "/business/attachments",
    name: "business-document-attachments",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/documentView/EntreatyAttac.vue"),
  },
  {
    path: "/search",
    name: "search-entreaty",
    meta: { layout: "LayoutsDefault", guest: true },
    component: () => import("../views/SearchEntreaty.vue"),
  },
  
  /* */
  {
    path: "/main",
    name: "main",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/MainView.vue"),
  },
  {
    path: "/entreaty-process",
    name: "entreaty-process",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/EntreatyProcess.vue"),
  },
  {
    path: "/change-password",
    name: "change-password",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/profile/ChangePassword.vue"),
  },
  {
    path: "/entreaty-add",
    name: "entreaty-add",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/EntreatyAdd.vue"),
  },
  {
    path: "/entreaty-add-v2",
    name: "entreaty-add-v2",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/entreaty_add_v2.vue"),
  },
  {
    path: "/entreaty-payment",
    name: "entreaty-payment",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/EntreatyPayment.vue"),
  },
  /* */
  {
    path: "/entreaty-timeline/:ent_id",
    name: "entreaty-timeline",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/EntreatyTimeline.vue"),
  },
  {
    path: "/entreaty-detail/:ent_id",
    name: "entreaty-detail",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/EntreatyDetail.vue"),
  },
  {
    path: "/entreaty-edit/:ent_id",
    name: "entreaty-edit",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/EntreatyEdit.vue"),
  },
  {
    path: "/entreaty-edit/application/:ent_id",
    name: "application-edit",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/edit/ApplicationEdit.vue"),
  },
  {
    path: "/entreaty-edit/attorney/:ent_id",
    name: "attorney-edit",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/entreaty/edit/AttorneyEdit.vue"),
  },
  /* */
  {
    path: "/ent-done",
    name: "document-ent-done",
    meta: { layout: "LayoutsMain", requiresAuth: true },
    component: () => import("../views/documentView/EntreatyDone.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('access_Token') == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
        next()
    }
  } else if (to.matched.some(record => record.meta.requiresNotAuth)) {
    if (localStorage.getItem('access_Token') == null) {
      next()
    } else {
      next({
        path: '/main',
        params: { nextUrl: to.fullPath }
      })
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    next()
  } else {
    next()
  }
})

export default router;
